/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Footer_Social_LabelInputs */

const en_footer_social_label = /** @type {(inputs: Footer_Social_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AnyAPI on ${i?.name}`)
};

const zh_hans1_footer_social_label = /** @type {(inputs: Footer_Social_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AnyAPI 的 ${i?.name}`)
};

const pt_br2_footer_social_label = /** @type {(inputs: Footer_Social_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AnyAPI no ${i?.name}`)
};

const es_footer_social_label = /** @type {(inputs: Footer_Social_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AnyAPI en ${i?.name}`)
};

const fr_footer_social_label = /** @type {(inputs: Footer_Social_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AnyAPI sur ${i?.name}`)
};

const de_footer_social_label = /** @type {(inputs: Footer_Social_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AnyAPI auf ${i?.name}`)
};

const ru_footer_social_label = /** @type {(inputs: Footer_Social_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AnyAPI в ${i?.name}`)
};

const it_footer_social_label = /** @type {(inputs: Footer_Social_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`AnyAPI su ${i?.name}`)
};

/**
* | output |
* | --- |
* | "AnyAPI on {name}" |
*
* @param {Footer_Social_LabelInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const footer_social_label = /** @type {((inputs: Footer_Social_LabelInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Social_LabelInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_footer_social_label(inputs)
	if (locale === "pt-BR") return pt_br2_footer_social_label(inputs)
	if (locale === "es") return es_footer_social_label(inputs)
	if (locale === "fr") return fr_footer_social_label(inputs)
	if (locale === "de") return de_footer_social_label(inputs)
	if (locale === "ru") return ru_footer_social_label(inputs)
	if (locale === "it") return it_footer_social_label(inputs)
	return en_footer_social_label(inputs)
});